module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon32.98e66b19.png";